import { AlertCircle, AlertTriangle, Clock } from "lucide-react";
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface CriticalAlertsCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export function CriticalAlertsCardThumbnail({
  isHovered = false,
  alwaysVisible,
}: CriticalAlertsCardThumbnailProps) {
  return (
    <ScaledThumbnail isHovered={isHovered} alwaysVisible={alwaysVisible}>
      <Card className="w-[300px] shadow-sm border-amber-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium flex items-center gap-2">
            Critical Alerts
            <AlertTriangle className="h-3 w-3 text-amber-600" />
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">Active Alerts</span>
            <span className="font-bold text-amber-600">3</span>
          </div>
          <div className="space-y-1.5 text-xs">
            <div className="flex items-start gap-2 p-1.5 bg-red-50 rounded">
              <AlertTriangle className="h-3 w-3 text-red-600 mt-0.5 flex-shrink-0" />
              <div>
                <div className="font-semibold text-red-900">
                  Low cash warning
                </div>
                <div className="text-red-700">Birmingham location</div>
              </div>
            </div>
            <div className="flex items-start gap-2 p-1.5 bg-amber-50 rounded">
              <AlertCircle className="h-3 w-3 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <div className="font-semibold text-amber-900">
                  Large payment due
                </div>
                <div className="text-amber-700">£85k payroll in 3 days</div>
              </div>
            </div>
            <div className="flex items-start gap-2 p-1.5 bg-amber-50 rounded">
              <Clock className="h-3 w-3 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <div className="font-semibold text-amber-900">
                  Forecast variance
                </div>
                <div className="text-amber-700">Review recommended</div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </ScaledThumbnail>
  );
}
